<template lang="pug">
  th(v-if='elementType == "th"', :id='getId',
    :data-coachmark='getOrder',
    :data-coachmark-text='getText',
    :data-coachmark-xPadding='getXPadding',
    :data-coachmark-yPadding='getYPadding',
    :data-coachmark-target='getTarget'
    :data-coachmark-type='getType',
    :data-coachmark-isTransparent='getIsTransparent'
  )
    slot
  .coachmark(v-else, :id='getId',
    :data-coachmark='getOrder',
    :data-coachmark-text='getText',
    :data-coachmark-xPadding='getXPadding',
    :data-coachmark-yPadding='getYPadding',
    :data-coachmark-target='getTarget'
    :data-coachmark-type='getType',
    :data-coachmark-isTransparent='getIsTransparent'
  )
    slot
</template>

<script>
export default {
  name: 'CoachmarkTip',
  props: {
    id: String,
    order: String,
    text: String,
    type: String,
    xPadding: String,
    yPadding: String,
    target: String,
    isTransparent: Boolean,
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    elementType: String
  },
  computed: {
    getId: function () {
      return this.options.id || this.id;
    },
    getOrder: function () {
      return this.options.order || this.order;
    },
    getText: function () {
      return this.options.text || this.text;
    },
    getType: function () {
      return this.options.type || this.type;
    },
    getXPadding: function () {
      return this.options.xPadding || this.xPadding;
    },
    getYPadding: function () {
      return this.options.yPadding || this.yPadding;
    },
    getTarget: function () {
      return this.options.target || this.target;
    },
    getIsTransparent: function () {
      return this.options.isTransparent || this.isTransparent;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .coachmark
    scroll-margin 50px
</style>
